import { ACCOUNT_STATE_TITLES } from '@monorepo/client-types';
import {
  AccountState,
  AccountStateKey,
  AccountStatus,
  ThemeColors,
} from '@monorepo/types';

type TagSetting = {
  color?: ThemeColors;
  tooltip?: string;
};

/**
 *
 */
export const getTagSettings = (status: AccountStatus, state?: AccountState) => {
  if (state && status === AccountStatus.Disabled) {
    const terminationSettings: Record<AccountStateKey, TagSetting> = {
      [AccountStateKey.DailyPause]: {
        color: ThemeColors.colorInfo,
        tooltip: ACCOUNT_STATE_TITLES[AccountStateKey.DailyPause],
      },
      [AccountStateKey.DailyLoss]: {
        color: ThemeColors.colorInfo,
        tooltip: ACCOUNT_STATE_TITLES[AccountStateKey.DailyLoss],
      },
      [AccountStateKey.Terminated]: {
        tooltip: ACCOUNT_STATE_TITLES[AccountStateKey.Terminated],
      },
      [AccountStateKey.Expired]: {
        color: ThemeColors.colorError,
        tooltip: ACCOUNT_STATE_TITLES[AccountStateKey.Expired],
      },
      [AccountStateKey.Target]: {
        color: ThemeColors.colorWarning,
        tooltip: ACCOUNT_STATE_TITLES[AccountStateKey.Target],
      },
    };

    const userTerminations: Array<TagSetting> = Object.entries(state)
      .filter(([_, value]) => value)
      .map(
        ([terminationState, _]) =>
          terminationSettings[terminationState as AccountStateKey],
      );

    if (userTerminations.length > 0) {
      return userTerminations[0];
    }
  }

  const tagColors: Record<AccountStatus, ThemeColors> = {
    [AccountStatus.Active]: ThemeColors.colorSuccess,
    [AccountStatus.Disabled]: ThemeColors.colorError,
    [AccountStatus.PendingCreation]: ThemeColors.colorInfo,
    [AccountStatus.ReachedTarget]: ThemeColors.colorSuccess,
    [AccountStatus.WaitingForRisk]: ThemeColors.colorBrand, // waiting for shelly to give color
    [AccountStatus.WaitingForWithdraw]: ThemeColors.colorBrand,
    [AccountStatus.AwaitingAsyncCreation]: ThemeColors.colorInfo,
    [AccountStatus.PendingAsyncCreation]: ThemeColors.colorInfo,
    [AccountStatus.AccountCreationFailure]: ThemeColors.colorError,
    [AccountStatus.AccountCreationDidntStart]: ThemeColors.colorError,
  };

  return { color: tagColors[status] };
};
